import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'longShort'
})

export class LongShortPipe implements PipeTransform {
  transform(value: string): string {
    if (value === 'L') {
      return "Long";
    }
    if (value === 'S') {
      return "Short";
    }
    return "";
  }
}
